import { Helper } from '@/services/helper/helper';

class AdServiceHelper {
	/**
	 * Returns the base url for AdService-Scripts
	 * @returns {string}
	 */
	static getScriptBaseUrl () {
		const CONNECTOR_VERSION = 25;

		let connectorVersion = CONNECTOR_VERSION;
		const forcedVersion = Helper.getUrlParam('connectorVersion');

		if (forcedVersion) {
			if (forcedVersion === 'prev') {
				connectorVersion--;
				if (connectorVersion <= 0) {
					connectorVersion = 1;
				}
			} else if (forcedVersion === 'next') {
				connectorVersion++;
			} else {
				connectorVersion = parseInt(forcedVersion, 10) || connectorVersion;
			}
		}

		return '//dl.' + window.SiteInfo.brandShort + '.' + window.SiteInfo.tld + '/uim/connector/' + connectorVersion + '/';
	}

	static servicePush (func) {
		window.AdService.push(func);
	}

	static listenEvent (eventName, func) {
		this.servicePush(() => {
			window.AdService.on(eventName, () => {
				func();
			});
		});
	}
}

export { AdServiceHelper };
